/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';


import Modal, { ModalHeader, ModalFooter } from '../../../../components/Modal';
import Button from '../../../../components/Button';

import styles from '../../../../styles';

import AllSeverityGrid from '../AllSeverityGrid';

const StyledAllSeverityGrid = styled(AllSeverityGrid)`
  margin-top: 1rem;
`;

const BodyWrapper = styled.div`
  padding: 1rem;
`;

const Label = styled.div`
  ${styles.fonts.headingLabelCaps}
`;

const Value = styled.div`
  ${styles.fonts.base};
  color: ${styles.colors.biscay};
`;

const Grid = styled.div`
  margin-top: 1rem;
`;

class EditAllSubscriptionModal extends React.Component {
  submit = () => {
    const { severityGrid, requests, onClose } = this.props;
    const statusObject = {
      major: severityGrid.state.major,
      minor: severityGrid.state.minor,
      maintenance: severityGrid.state.maintenance,
    };

    let body = {};
    const productKey = this.props.subscription.productKey;
    if (productKey) {
      const product = {};
      product[productKey] = statusObject;  

      body = {
        "emailAddress": this.props.subscriberAddress,
        "subscriptions": {
            "products": product
          }
        }
    } else {
      body = Object.assign({ type: 'ALL' }, statusObject);
    }

    const promise = productKey ?
      requests.postProductSubscription.handleRequest({ body }) :
      requests.postSubscription.handleRequest({ body });

    promise
    .then(() => {
      requests.subscriber.handleRequest();
      onClose('success', 'Your subscription has been successfully edited!');
    })
    .catch((errop) => {
      requests.subscriber.handleRequest();
      onClose('failure', 'There was an error. Please try again');
    });
  }

  UNSAFE_componentWillMount() {
    const { subscription } = this.props;
    this.props.severityGrid.actions.load(subscription);
  }

  render() {
    return (
      <Modal onClose={this.props.onClose}>
        <ModalHeader text='Edit Subscription' />
        <BodyWrapper>
          <Label>
            { this.props.label || 'Instance' }
          </Label>
          <Value>
            { this.props.valueText || 'All Instances' }
          </Value>
          <Grid>
            <Label>
              { this.props.tableLabel || 'Select Services and Severities' }
            </Label>
            <StyledAllSeverityGrid
              severityGrid={this.props.severityGrid}
            />
          </Grid>
        </BodyWrapper>
        <ModalFooter>
          <Button onClick={this.props.onClose}>Cancel</Button>
          <Button theme='brand' onClick={this.submit}>Submit</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default EditAllSubscriptionModal;
